export default "__VITE_ASSET__DrwyUYq8__"